<template>
    <a href="#modal" @click.prevent="toggleModal">
        <slot></slot>
    </a>
</template>

<script>
import { bus } from '@/app';

export default {
    name: 'Ui.ModalToggle',

    props: {
        name: {
            type: String,
            required: true,
        },
    },

    methods: {
        toggleModal() {
            bus.$emit('modal', this.name);
        },
    },
};
</script>
